import { Field } from '@datx/core';
import { JsonApiModel } from '../core/jsonApi/jsonApiModel';
import { ConsumerData } from '../core/types';

export class TestJsonModel extends JsonApiModel {
  public static override readonly type = 'tests';

  @Field({ isIdentifier: true })
  public id!: string;

  @Field()
  public active!: boolean;

  @Field()
  public approval!: string;

  @Field()
  public changedBy!: string;

  @Field()
  public consumerData!: ConsumerData;

  @Field()
  public consumerId!: string;

  @Field()
  public copyRestricted!: boolean;

  @Field()
  public kind!: string;

  @Field()
  public name!: string;

  @Field()
  public sequenceIds!: [];

  @Field()
  public subjectId!: string;

  @Field()
  public version!: number;
}
